var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AntFormItem',{staticClass:"checkbox"},[_c('AntCheckbox',_vm._g(_vm._b({directives:[{name:"decorator",rawName:"v-decorator",value:([_vm.name, {
      rules: _vm.validationRules,
      preserve: _vm.preserve,
    }]),expression:"[name, {\n      rules: validationRules,\n      preserve,\n    }]"}]},'AntCheckbox',_vm.$attrs,false),_vm.checkboxListeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }